import { useCallback, useState } from "react";

export const useFormFocus = <T extends Record<string, boolean>>(
  initialState: T
) => {
  const [focusedFields, setFocusedFields] = useState<T>(initialState);

  const handleFieldFocus = useCallback((field: string, isFocused: boolean) => {
    setFocusedFields((prev) => ({ ...prev, [field]: isFocused }));
  }, []);

  const handleFieldBlur = useCallback((field: string) => {
    setFocusedFields((prev) => ({ ...prev, [field]: false }));
  }, []);

  return {
    focusedFields,
    handleFieldFocus,
    handleFieldBlur,
  };
};
